"use strict";import{IllustratedMessage as e}from"./src/IllustratedMessage.js";customElements.define("sp-illustrated-message",e);
//# sourceMappingURL=sp-illustrated-message.js.map
